import React from "react";

export default function OhDear() {
  return (
    <div
      // Directly styled as we don't know what the CSS will be like, try and be as defensive as possible.
      style={{
        width: "50%",
        height: "100%",
        backgroundColor: "white",
        textAlign: "center",
        verticalAlign: "middle",
        margin: "10em",
        padding: "2em",
        borderRadius: "1em",
        border: "1px solid black",
        fontSize: "22px",
      }}
    >
      Lexis® has encountered an error processing your request. Please verify
      that you are connected to the internet and that you are still signed in to
      Lexis. If those steps don't correct the problem, please restart your
      browser. We apologize for the inconvenience. If you continue to have
      problems, please call Customer Support at{" "}
      <a href="tel:+1-800-543-6862">1-800-543-6862</a>.
    </div>
  );
}
